import { Action } from '@ngrx/store';

export const ERROR = 'ERROR';
export const SUCCESS = 'SUCCESS';
export const RESET = 'RESET';

export class NotificationErrorAction implements Action {
    public type = ERROR;
    /**
     * @deprecated Global notification should not be used. It has been replaced
     * by the snack bar service.
     */
    constructor(public payload: string) { }
}

export class NotificationSuccessAction implements Action {
    public type = SUCCESS;
    /**
     * @deprecated Global notification should not be used. It has been replaced
     * by the snack bar service.
     */
    constructor(public payload: string) { }
}
export class NotificationResetAction implements Action {
    public type = RESET;
    /**
     * @deprecated Global notification should not be used. It has been replaced
     * by the snack bar service.
     */
    constructor(public payload: string) { }
}

export type GlobalNotificationActions = NotificationErrorAction | NotificationSuccessAction | NotificationResetAction;
